document.addEventListener('DOMContentLoaded', function () {
  var BTW_RATE = 1.21;

  function parsePrice(text) {
    var m = text.match(/\d[\d.,]*\d|\d/);
    if (!m) return null;
    var raw = m[0];
    var lastSep = null;
    var lastSepIndex = -1;
    for (var i = raw.length - 1; i >= 0; i--) {
      if (raw.charAt(i) === '.' || raw.charAt(i) === ',') {
        lastSep = raw.charAt(i);
        lastSepIndex = i;
        break;
      }
    }
    var integerPart, decimalPart, decimalSep;
    if (lastSep && raw.length - lastSepIndex - 1 === 2) {
      decimalSep = lastSep;
      integerPart = raw.slice(0, lastSepIndex).replace(/[.,]/g, '');
      decimalPart = raw.slice(lastSepIndex + 1);
    } else {
      decimalSep = ',';
      integerPart = raw.replace(/[.,]/g, '');
      decimalPart = '00';
    }
    var value = parseFloat(integerPart + '.' + decimalPart);
    if (isNaN(value)) return null;
    return {
      value: value,
      decimalSep: decimalSep,
      matchIndex: m.index,
      matchText: m[0]
    };
  }

  function formatValue(value, decimalSep) {
    var rounded = Math.round((value + Number.EPSILON) * 100) / 100;
    var parts = rounded.toFixed(2).split('.');
    var intPart = parts[0];
    var decPart = parts[1];
    var thousandsSep = decimalSep === ',' ? '.' : ',';
    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
    return intPart + decimalSep + decPart;
  }

  function buildText(original, parsed, newValue) {
    var newRaw = formatValue(newValue, parsed.decimalSep);
    return original.slice(0, parsed.matchIndex) + newRaw + original.slice(parsed.matchIndex + parsed.matchText.length);
  }

  function computeEntries(priceContainer) {
    var spans = priceContainer.querySelectorAll('.price-item--regular, .price-item--sale.price-item--last');
    var entries = [];
    spans.forEach(function (span) {
      if (span.closest('s')) return;
      var originalText = span.textContent;
      var parsed = parsePrice(originalText);
      if (!parsed) return;
      var exclValue = parsed.value / BTW_RATE;
      var exclText = buildText(originalText, parsed, exclValue);
      entries.push({ span: span, inclText: originalText, exclText: exclText });
    });
    return entries;
  }

  var toggleState = {
    priceContainer: null,
    toggle: null,
    inclBtn: null,
    exclBtn: null,
    mode: 'incl',
    entries: []
  };

  function applyMode(mode) {
    toggleState.mode = mode;
    toggleState.entries.forEach(function (entry) {
      entry.span.textContent = mode === 'excl' ? entry.exclText : entry.inclText;
    });
    if (toggleState.inclBtn && toggleState.exclBtn) {
      [toggleState.inclBtn, toggleState.exclBtn].forEach(function (btn) {
        var isActive = btn.getAttribute('data-btw-mode') === mode;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    }
  }

  function buildToggle(priceContainer) {
    var toggle = document.createElement('div');
    toggle.className = 'btw-toggle';
    toggle.setAttribute('data-btw-toggle', '');

    var inclBtn = document.createElement('button');
    inclBtn.type = 'button';
    inclBtn.className = 'btw-toggle__btn is-active';
    inclBtn.setAttribute('data-btw-mode', 'incl');
    inclBtn.setAttribute('aria-pressed', 'true');
    inclBtn.textContent = 'Incl BTW';

    var exclBtn = document.createElement('button');
    exclBtn.type = 'button';
    exclBtn.className = 'btw-toggle__btn';
    exclBtn.setAttribute('data-btw-mode', 'excl');
    exclBtn.setAttribute('aria-pressed', 'false');
    exclBtn.textContent = 'Excl BTW';

    toggle.appendChild(inclBtn);
    toggle.appendChild(exclBtn);

    priceContainer.insertAdjacentElement('afterend', toggle);

    inclBtn.addEventListener('click', function () {
      applyMode('incl');
    });
    exclBtn.addEventListener('click', function () {
      applyMode('excl');
    });

    return { toggle: toggle, inclBtn: inclBtn, exclBtn: exclBtn };
  }

  function syncToggle(priceContainer) {
    if (!priceContainer) return;
    if (priceContainer.closest('.volume-pricing-note, price-per-item, volume-pricing')) return;
    if (priceContainer.parentElement && priceContainer.parentElement.querySelector('.volume-pricing-note')) return;

    var entries = computeEntries(priceContainer);
    if (entries.length === 0) return;

    toggleState.priceContainer = priceContainer;
    toggleState.entries = entries;

    if (!toggleState.toggle || !document.body.contains(toggleState.toggle)) {
      var built = buildToggle(priceContainer);
      toggleState.toggle = built.toggle;
      toggleState.inclBtn = built.inclBtn;
      toggleState.exclBtn = built.exclBtn;
    }

    applyMode(toggleState.mode);
  }

  function hideTaxNotice() {
    var taxNotice = document.querySelector('product-info .product__tax');
    if (taxNotice) taxNotice.style.display = 'none';
  }

  var mainPriceContainer = document.querySelector('product-info [id^="price-"]');
  if (mainPriceContainer) {
    syncToggle(mainPriceContainer);
    hideTaxNotice();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        syncToggle(document.querySelector('product-info [id^="price-"]'));
        hideTaxNotice();
      });
    }
  }
});
